import Base from "./Base"

export default {
  httpBaseUri: "https://local.operandiodev.com:5022",
  httpServiceBaseUri: "https://local.operandiodev.com:5022/graphql",
  wsServiceBaseUri: "wss://local.operandiodev.com:5022/graphql",

  showConfigInTitle: true,
  configTitle: "[LOCALTEST]",

  theme: {
    logoContainer: "images-dev"
  },

  uploader: {
    ...Base.uploader,

    imageViewerBaseUri: "https://image.operandio.com",
    // imageViewerBucketName: "operandio-content-dev",
    imageViewerBucketName: "operandio-content-ap-southeast-2",

    videoViewerBaseUri: "https://dev-video.operandiodev.com",
    videoViewerBucketName: "dev-operandio-content-ap-southeast-2",

    scormUploadBucketName: "dev-operandio-scorm-quarantine",
    scormViewerBaseUri: "https://dev-scorm.operandiodev.com"
  },

  errors: {
    ...Base.errors,

    showDetail: false,
    showGraphQLErrorNotification: true
  }
}
